import { render, staticRenderFns } from "./Loss.vue?vue&type=template&id=33d49f4a&scoped=true"
import script from "./Loss.vue?vue&type=script&lang=js"
export * from "./Loss.vue?vue&type=script&lang=js"
import style0 from "./Loss.vue?vue&type=style&index=0&id=33d49f4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d49f4a",
  null
  
)

export default component.exports